Wee.fn.make('equalHeights', {
	init: function() {
		var priv = this.$private,
			$blocks = $('ref:equalHeights');

		if ($blocks) {
			priv.setEqualHeights();
		}
	}
}, {

	/**
	 * Set all blocks height to tallest in set
	 *
	 * @private
	 */
	setEqualHeights: function() {
		var $blocks = $('ref:equalHeights'),
			heights = [],
			maxHeight = 0;

		heights = Wee.$map($blocks, function(el, i) {
			return $(el).height();
		});

		maxHeight = Math.max.apply(null, heights);

		$blocks.height(maxHeight);
	}
});